import { useCallback, useMemo } from "react";
import { usePage } from "@inertiajs/react";
import { SnowplowTracker } from "@/utils/snowplow_tracker";
import useDevice from "@/hooks/use_device";

export enum SnowplowEvent {
  SearchResultClicked = "mygreenhouse.job_search.result_clicked",
  ResumeModalShown = "mygreenhouse.resume.modal.shown",
  ResumeModalDismissed = "mygreenhouse.resume.modal.dismissed",
  ResumeModalConfirmed = "mygreenhouse.resume.modal.confirmed",
  ResumeUploadStarted = "mygreenhouse.resume.upload.started",
  ResumeUploadCompleted = "mygreenhouse.resume.upload.completed",
  ResumeUploadFailed = "mygreenhouse.resume.upload.failed",
  ResumeUploadAborted = "mygreenhouse.resume.upload.aborted",
  ResumeUploaded = "mygreenhouse.resume.uploaded",
}

export const useSnowplowTracker = () => {
  const tracker = useMemo(() => new SnowplowTracker(), []);
  const { currentUserId } = usePage<{ currentUserId?: number }>().props;
  const { isMobile } = useDevice();

  const trackEvent = useCallback(
    (eventName: string, data: Record<PropertyKey, string | number | undefined>) => {
      tracker &&
        tracker.track({
          name: eventName,
          data: {
            ...data,
            user_id: currentUserId,
            device_type: isMobile ? "mobile" : "desktop",
            timestamp: Date.now(),
          },
        });
    },
    [tracker, currentUserId, isMobile],
  );

  return { trackEvent };
};
